import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CustomActionButton from '../../../common/CustomActionButton';
import CustomInputV2 from '../../../common/CustomInputV2';
import { delay, generateRandomNumber } from '../../../utils';

import { SendVerificationCode, UpdateCompanyName } from '../../../redux/company/actions';
import toast from 'react-hot-toast';

const ChangeCompanyName = (props) => {
    const { organization, setWrapperChanger } = props;
    const [name, setName] = useState('');
    const [sentCode, setSentCode] = useState("");
    const [code, setCode] = useState('');
    const [codeVerified, setCodeVerified] = useState(false);
    const [status, setStatus] = useState(0);

    const sideIcon = [
        "",
        <CircularProgress sx={{ color: '#d1d1d1' }} className="verif-loader" />,
        <CheckCircleIcon sx={{ fontSize: 30, color: '#99B93C', mr: -1 }} />,
        <CancelIcon sx={{ fontSize: 30, color: 'red', mr: -1 }} />,
    ]

    const GenerateNumber = () => {
        let number = generateRandomNumber(999999);
        number = (number + "").padStart(6, "0");
        setSentCode(number);

        return;
    }

    useEffect(async () => {
        if (sentCode && organization.table_id) {
            const res = await props.SendVerificationCode(organization?.name, sentCode);
            if (!res) {
                toast.error("Unable to send verification code.");
            }
        }
    }, [sentCode]);

    useEffect(() => {
        GenerateNumber();
    }, []);

    return (
        <div className='flex-c'>
            <div style={{ width: "100%", maxWidth: "400px" }}>
                <p className='text text-center'>A one-time code has been sent to Steve Gonser. It will expire in 10 mins.</p>
                <Box display="flex" sx={{ justifyContent: 'center', mb: '20px' }}>
                    <CustomInputV2
                        placeholder="Enter Code"
                        value={code}
                        onChange={(e) => {
                            setCode(e.target.value);
                            setStatus(1);
                        }}
                        onBlur={() => {
                            delay(() => {
                                if (code == sentCode) {
                                    setStatus(2);
                                    setCodeVerified(true);
                                } else {
                                    setStatus(3);
                                    setCodeVerified(false);
                                }
                            }, 2000)
                        }}
                        style={{ textAlign: "center" }}
                        RightIcon={sideIcon[status]}
                    />
                </Box>
                <Box display="flex" sx={{ justifyContent: 'center', mb: '30px' }}>
                    <CustomInputV2
                        placeholder="Enter Name"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                        }}
                        style={{ textAlign: "center" }}
                    />
                </Box>
                <Box display="flex" sx={{ justifyContent: 'space-between' }}>
                    <button className='secondary-button' onClick={() => setWrapperChanger('')}>BACK</button>
                    <CustomActionButton disabled={!(codeVerified && name)} action={async () => {
                        const res = await props.UpdateCompanyName(organization.table_id, name);
                        if (res) {
                            toast.success("Successfully Updated.")
                        } else {
                            toast.error("Failed Updated.")
                        }
                        return res;
                    }}>SUBMIT</CustomActionButton>
                </Box>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    SendVerificationCode,
    UpdateCompanyName,
})(ChangeCompanyName);
